import _map from 'lodash/map';

import {
  RECURRING_FILTER_OPTIONS,
  STATUS_FILTER_OPTIONS,
  FILTERS_OPTIONS,
} from './SchedulesBoard/SchedulesBoard.helpers';

export const SET_SCHEDULES_BOARD_CLASS_FILTERS = 'SCHEDULES/SET_SCHEDULES_BOARD_CLASS_FILTERS';
export const setSchedulesBoardClassesFilters = classes => ({ type: SET_SCHEDULES_BOARD_CLASS_FILTERS, classes });

export const SET_SCHEDULES_BOARD_DURATIONS_FILTERS = 'SCHEDULES/SET_SCHEDULES_BOARD_DURATIONS_FILTERS';
export const setSchedulesBoardDurationsFilters = durations => ({
  type: SET_SCHEDULES_BOARD_DURATIONS_FILTERS,
  durations,
});

export const SET_SCHEDULES_BOARD_STATUS_FILTERS = 'SCHEDULES/SET_SCHEDULES_BOARD_STATUS_FILTERS';
export const setSchedulesBoardStatusFilters = keys => ({ type: SET_SCHEDULES_BOARD_STATUS_FILTERS, keys });

export const SET_SCHEDULES_BOARD_INSTRUCTOR_FILTERS = 'SCHEDULES/SET_SCHEDULES_BOARD_INSTRUCTOR_FILTERS';
export const setSchedulesBoardInstructorsFilters = instructors => ({
  type: SET_SCHEDULES_BOARD_INSTRUCTOR_FILTERS,
  instructors,
});

export const SET_SCHEDULES_BOARD_TYPE_FILTERS = 'SCHEDULES/SET_SCHEDULES_BOARD_TYPE_FILTERS';
export const setSchedulesBoardTypeFilters = keys => ({ type: SET_SCHEDULES_BOARD_TYPE_FILTERS, keys });

export const SET_SELECTED_SCHEDULE_INSTANCE_ID = 'SCHEDULES/SET_SELECT_SCHEDULE_INSTANCE_ID';
export const setSelectedScheduleInstanceId = ({ instanceId }) => ({
  type: SET_SELECTED_SCHEDULE_INSTANCE_ID,
  instanceId,
});

export const SET_CREATED_CLASS_ID = 'SCHEDULES/SET_CREATED_CLASS_ID';
export const setCreatedClassId = classId => ({ type: SET_CREATED_CLASS_ID, classId });

export const SET_CREATED_INSTRUCTOR_ID = 'SCHEDULES/SET_CREATED_INSTRUCTOR_ID';
export const setCreatedInstructorId = instructorId => ({ type: SET_CREATED_INSTRUCTOR_ID, instructorId });

export const SET_NEXT_DATE = 'SCHEDULES/SET_NEXT_DATE';
export const setNextDate = nextDate => ({ type: SET_NEXT_DATE, nextDate });

const getFiltersQuery = keys => {
  const filterQueries = keys.map(key => {
    const filterOption = FILTERS_OPTIONS.find(item => item.key === key);
    return filterOption ? filterOption.query : null;
  });

  return filterQueries.filter(Boolean);
};

const getClassQuery = classId => {
  if (!classId) {
    return null;
  }
  return `class_id:${classId}`;
};

const getDurationQuery = duration => {
  if (!duration) {
    return null;
  }
  return `duration:${duration}`;
};

const getInstructorQuery = instructorId => {
  if (!instructorId && instructorId !== null) {
    return null;
  }
  return `instructor_id:${instructorId}`;
};

const getInitialState = () => ({
  schedulesBoardStatusFiltersKeys: _map(STATUS_FILTER_OPTIONS, 'key'),
  schedulesBoardStatusFiltersQueries: _map(STATUS_FILTER_OPTIONS, 'query'),
  schedulesBoardTypeFiltersKeys: _map(RECURRING_FILTER_OPTIONS, 'key'),
  schedulesBoardTypeFiltersQueries: _map(RECURRING_FILTER_OPTIONS, 'query'),
  schedulesBoardClassesFiltersQueries: [],
  schedulesBoardClassesFilters: [],
  schedulesBoardDurationsFiltersQueries: [],
  schedulesBoardDurationsFilters: [],
  schedulesBoardInstructorsFiltersQueries: [],
  schedulesBoardInstructorsFilters: [],
  selectedScheduleInstanceId: null,
  createdClassId: null,
  createdInstructorId: null,
  startDate: new Date().toISOString(),
  nextDate: null,
});

export default (state = getInitialState(), action) => {
  const { classes, durations, instructors, type, keys, instanceId, classId, instructorId, nextDate } = action;

  switch (type) {
    case SET_SCHEDULES_BOARD_STATUS_FILTERS:
      return {
        ...state,
        schedulesBoardStatusFiltersKeys: keys,
        schedulesBoardStatusFiltersQueries: getFiltersQuery(keys),
        nextDate: getInitialState().nextDate,
        selectedScheduleInstanceId: getInitialState().selectedScheduleInstanceId,
      };

    case SET_SCHEDULES_BOARD_TYPE_FILTERS:
      return {
        ...state,
        schedulesBoardTypeFiltersKeys: keys,
        schedulesBoardTypeFiltersQueries: getFiltersQuery(keys),
        nextDate: getInitialState().nextDate,
        selectedScheduleInstanceId: getInitialState().selectedScheduleInstanceId,
      };

    case SET_SCHEDULES_BOARD_CLASS_FILTERS:
      return {
        ...state,
        schedulesBoardClassesFilters: classes,
        schedulesBoardClassesFiltersQueries: classes.map(getClassQuery),
      };

    case SET_SCHEDULES_BOARD_DURATIONS_FILTERS:
      return {
        ...state,
        schedulesBoardDurationsFilters: durations,
        schedulesBoardDurationsFiltersQueries: durations.map(getDurationQuery),
      };

    case SET_SCHEDULES_BOARD_INSTRUCTOR_FILTERS:
      return {
        ...state,
        schedulesBoardInstructorsFilters: instructors,
        schedulesBoardInstructorsFiltersQueries: instructors.map(getInstructorQuery),
      };

    case SET_SELECTED_SCHEDULE_INSTANCE_ID:
      return { ...state, selectedScheduleInstanceId: parseInt(instanceId, 10) };

    case SET_CREATED_CLASS_ID:
      return { ...state, createdClassId: classId };

    case SET_CREATED_INSTRUCTOR_ID:
      return { ...state, createdInstructorId: instructorId };

    case SET_NEXT_DATE:
      return { ...state, nextDate };

    default:
      return state;
  }
};
